import { ValidationUtils } from '@assertiva/assertiva-ui';
import { CrossProductActionParams } from '@stores/crossProductAction/types';

const PARAM_KEYS = ['doc', 'docType', 'name', 'email', 'phoneNumber'] as const;

function inferDocType(doc: string): 'cpf' | 'cnpj' | undefined {
  if (ValidationUtils.isValidCpf(doc)) return 'cpf';
  if (ValidationUtils.isValidCnpj(doc)) return 'cnpj';
  return undefined;
}

export function parseParams(
  searchParams: URLSearchParams
): CrossProductActionParams | null {
  const hasAnyParam = PARAM_KEYS.some((key) => searchParams.has(key));
  if (!hasAnyParam) return null;

  const doc = searchParams.get('doc') || undefined;
  const docType = (searchParams.get('docType') as 'cpf' | 'cnpj') || undefined;
  const name = searchParams.get('name') || undefined;
  const email = searchParams.get('email') || undefined;
  const phoneNumber = searchParams.get('phoneNumber') || undefined;

  let resolvedDocType: 'cpf' | 'cnpj' | undefined = docType;
  if (doc && !docType) {
    resolvedDocType = inferDocType(doc);
    // Doc ambíguo — inclui sem docType para tratamento no hook de execução
    if (!resolvedDocType) {
      return { doc, name, email, phoneNumber };
    }
  }

  if (doc && resolvedDocType) {
    const isValid =
      resolvedDocType === 'cpf'
        ? ValidationUtils.isValidCpf(doc)
        : ValidationUtils.isValidCnpj(doc);
    if (!isValid) {
      // Doc inválido — retorna params sem doc
      return name || email || phoneNumber ? { name, email, phoneNumber } : null;
    }
  }

  return { doc, docType: resolvedDocType, name, email, phoneNumber };
}

// Captura síncrona antes de qualquer redirect do React Router
// Usamos let para poder nullificar após consumo (evita re-processamento em remounts).
export let initialCrossProductParams: CrossProductActionParams | null =
  parseParams(new URLSearchParams(window.location.search));

/**
 * Nullifica os params capturados para que remounts subsequentes do hook
 * não re-despachem os mesmos valores ao Redux.
 */
export function consumeInitialParams() {
  initialCrossProductParams = null;
}
